import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OneDriveService {
  private clientId = environment.azureAd.clientId;
  private tenantId = environment.azureAd.tenantId;
  private clientSecret = environment.azureAd.clientSecret; // Solo para flujo server-side
  private accessToken: string | null = null;
  private redirectUri = 'http://localhost:4200/auth';
  private scopes = ['Files.Read'];

  constructor(private router: Router) {}

  async login(): Promise<void> {
    const nonce = this.generateNonce();
    localStorage.setItem('msal.nonce', nonce);

    const authUrl = `https://login.microsoftonline.com/${this.tenantId}/oauth2/v2.0/authorize?` +
      `client_id=${this.clientId}` +
      `&response_type=token` +
      `&redirect_uri=${encodeURIComponent(this.redirectUri)}` +
      `&scope=${encodeURIComponent(this.scopes.join(' '))}` +
      `&response_mode=fragment` +
      `&nonce=${nonce}`;

    window.location.href = authUrl;
  }

  async handleRedirect(): Promise<string | null> {
    const fragment = window.location.hash.substring(1);
    const params = new URLSearchParams(fragment);
    const token = params.get('access_token');
    
    if (token) {
      localStorage.setItem('msal.token', token);
      this.router.navigate(['/']);
      return token;
    }
    return null;
  }

  async getAccessToken(): Promise<string> {
    const token = localStorage.getItem('msal.token');
    if (!token) {
      await this.login();
      return '';
    }
    return token;
  }

  private generateNonce(): string {
    return Math.random().toString(36).substring(2, 15) + 
           Math.random().toString(36).substring(2, 15);
  }

  async downloadFile(email: string, filePath: string): Promise<Blob> {
    const token = await this.getAccessToken();
    const encodedPath = encodeURIComponent(filePath);
    const url = `https://graph.microsoft.com/v1.0/users/${email}/drive/root:/${encodedPath}:/content`;

    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error al descargar archivo: ${response.statusText}`);
    }

    return await response.blob();
  }
}